var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRmb = function SvgRmb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14a13.85 13.85 0 0 1-1.876 7C23.716 25.2 19.18 28 14 28c-5.18 0-9.716-2.8-12.124-7A13.85 13.85 0 0 1 0 14c0-2.548.672-4.956 1.876-7C4.284 2.8 8.82 0 14 0c5.18 0 9.716 2.8 12.124 7C27.328 9.044 28 11.452 28 14Z",
    fill: "#E32B25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.476 8.12 2.828.364L8.288 10.5l.504 2.828-2.548-1.316-2.492 1.372.448-2.828-2.072-1.96 2.828-.448L6.16 5.572 7.476 8.12ZM13.44 7.084l.476-.028-.28.392.168.476-.476-.168-.392.308v-.476l-.392-.28.476-.168.14-.476.28.42ZM12.18 4.732l.448-.168-.14.476.336.364-.504.028-.252.42-.168-.476-.476-.112.364-.308-.028-.476.42.252ZM13.3 12.292l.392.308-.476.112-.196.448-.252-.42h-.476l.308-.392-.14-.476.448.196.42-.28-.028.504ZM13.832 9.688l.448.168-.392.252v.504l-.392-.308-.476.14.168-.448-.28-.392h.504l.28-.392.14.476Z",
    fill: "#FDDB00"
  })));
};
export default SvgRmb;